/** Leaks tab for a creator: reuse existing /admin/leaks listing, filtered owner. */
import { useEffect, useState } from "react";
import { Link, useOutletContext } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowRight, WarningCircle } from "@phosphor-icons/react";
import { leaksAdminApi } from "../../../api/leaks";
import LeakStatusBadge from "../../../components/leaks/LeakStatusBadge";
import PortalEmptyState from "../../../components/portal/PortalEmptyState";

export default function AdminModelLeaks() {
  const { t } = useTranslation();
  const { model } = useOutletContext();
  const userId = model?.user_id;
  const [leaks, setLeaks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!userId) {
      setLoading(false);
      return;
    }
    (async () => {
      try {
        const all = await leaksAdminApi.list();
        setLeaks(all.filter((l) => l.owner_id === userId));
      } finally {
        setLoading(false);
      }
    })();
  }, [userId]);

  if (loading) return <p className="text-sm text-slate-500">{t("common.loading")}</p>;

  if (leaks.length === 0) {
    return (
      <PortalEmptyState
        variant="dashed"
        icon={WarningCircle}
        titleKey="models.tabs.leaks_empty"
        descKey="models.tabs.leaks_empty_desc"
      />
    );
  }

  return (
    <div data-testid="model-leaks-tab" className="space-y-2">
      {leaks.map((l) => (
        <Link
          key={l.id}
          to={`/admin/leaks/${l.id}`}
          className="group flex items-center gap-4 rounded-2xl border border-slate-200 bg-white px-5 py-4 hover:border-slate-900 transition-colors"
        >
          <div className="flex-1 min-w-0">
            <p className="text-sm font-medium text-slate-900 truncate">{l.title}</p>
            <p className="text-xs text-slate-500 truncate">{l.url}</p>
          </div>
          <LeakStatusBadge status={l.status} />
          <ArrowRight size={16} weight="bold" className="text-slate-400 group-hover:text-slate-900 group-hover:translate-x-1 transition-all" />
        </Link>
      ))}
    </div>
  );
}
